/**
 * DOC HELPER — OBJ-09 frontend context authority projection.
 *
 * This file only converts backend `context_authority.v1` into display-safe
 * labels and counts. It must not infer missing facts, mutate context, or decide
 * workflow state; the backend remains the single source of truth.
 */

function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
}

function coerceCount(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return 0;
  }
  return Math.max(0, Math.round(parsed));
}

export function resolveLatestContextAuthority(items) {
  const timelineItems = Array.isArray(items) ? items : [];
  return timelineItems.reduceRight((selected, item) => {
    if (selected) return selected;
    if (String(item?.type || '').trim() !== 'message' || String(item?.role || '').trim() !== 'assistant') {
      return null;
    }
    return resolveObject(item.contextAuthority);
  }, null);
}

export function buildAuthorityStats(authority) {
  const record = resolveObject(authority);
  if (!record) {
    return null;
  }
  const counts = resolveObject(record.counts);
  if (!counts) {
    return null;
  }
  return {
    factsCount: coerceCount(counts.facts),
    unknownsCount: coerceCount(counts.unknowns),
    evidenceCount: coerceCount(counts.evidence),
    turnsCount: coerceCount(counts.turns),
    artifactContextCount: coerceCount(counts.artifact_context),
    hasArchiveSummary: coerceCount(counts.graph_nodes) > 0 || coerceCount(counts.graph_edges) > 0,
    graphNodesCount: coerceCount(counts.graph_nodes),
    graphEdgesCount: coerceCount(counts.graph_edges),
    completenessScore: 0,
    updatedAt: String(record.persistence?.updated_at || ''),
  };
}

export function buildAuthorityLabel(authority) {
  const record = resolveObject(authority);
  if (!record) {
    return '';
  }
  const owner = String(record.owner || '').trim() === 'backend' ? '后端' : String(record.owner || '').trim();
  const policy = String(record.frontend_policy || '').trim() === 'projection_only' ? '前端仅展示' : '';
  return [owner ? `权威上下文 ${owner}` : '权威上下文', policy].filter(Boolean).join(' · ');
}
